<template>
    <div class="ranking-list-item" :class="{ me: isMe }">
        <div class="ranking-num" v-if="isMe">
            <p>我</p>
            <p class="color-red">{{ item.rnk }}</p>
        </div>
        <div class="ranking-num" v-else>
            <p v-if="item.rnk > 3">{{ item.rnk }}</p>
            <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${item.rnk}.png`" alt="">
        </div>
        <div class="ranking-name">
            <van-image class="img" round :src="item.avatar" error-icon="" />
            <div class="ellipsis" v-if="status === '3'">{{ item.storeName }}</div>
            <div v-else class="ellipsis">
                <div>{{ item.employeeName }}</div>
                <div class="ellipsis">{{ item.storeName }}</div>
            </div>
        </div>
        <div class="ranking-order" v-if="status !== '2'">{{ item.scoreData }}</div>
        <div v-if="status !== '3'" class="ranking-bonus">{{ `${status == 1 ? item.award : status == 2 ? item.scoreData : ''}${status !== '2' ? '元' : ''}` }}</div>
        <div v-if="status === '3'" class="ranking-bonus">
            <img class="flagImg" v-if="item.isAward != 0" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-03-05/flags.png"></img>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            item: {
                type: Object,
                default: () => { }
            },
            isMe: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: 0
            },
            status: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {

            }
        },
        methods: {
            // 获取主题色和图片和文字
            getTheme(type) {
                const index = this.status * 1 - 1
                const theme = {
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#F1DEA9', '#F6F2FF', '#F6F2FF'],
                    order: ['netAmtBfBcBody', 'custflowBfNetBcF0Mtd', 'saleAmtBfSelfBc', 'accountAmtMtd', 'accountAmtMtd'], // 金额对应字段
                }
                return theme[type][index];
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            padding: 20px;
            margin-top: 30px;
            background-color: #FDE3D7;
            border-radius: 12px;
            border: none;
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 60px;
            margin-right: 30px;

            p {
                margin: 0;
                text-align: center;
            }

            .color-red {
                color: #AB080B;
            }

            >img {
                width: 50px;
                height: 60px;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            width: 240px;

            div {
                width: 100%;
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

        }

        .ranking-order {
            width: 160px;
            text-align: center;
        }

        .ranking-bonus {
            width: 180px;
            text-align: center;
        }

        .flagImg {
            width: 65px;
            height: 54px;
        }
    }
</style>
